import { createStyles } from '@mantine/core'

export default createStyles((theme) => ({
  scrollArea: {
    width: '100%',
    maxHeight: '50vh',
  },
}))
